import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useStateContext } from "../../contexts/ThemeContext";
import { ReactComponent as MainIconSvg } from "../../assets/settingPage/setting-2.svg";
import { ReactComponent as MainIconSvgDark } from "../../assets/settingPage/setting-2-dark.svg";

import SettingSideBar from "../../components/dashboard/SettingSideBar";
import useLocales from "../../hooks/useLocales";
import { useSelector } from "react-redux";

// Setting pages layout, It Will render pages with settings menu (side bar)

const SettingPageLayout = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { setActiveSettingPageNav } = useStateContext();

  useEffect(() => {
    setActiveSettingPageNav(true);
    return () => {
      setActiveSettingPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div>
        <div className="bg-light_bg_v4 dark:bg-dark-primary h-[100vh] overflow-y-auto">
          <div className="hidden mb-[30px] md:flex items-center mt-10 gap-[10px] px-6 md:px-[50px] lg:px-[75px] xl:px-[100]">
            <div
              style={{
                boxShadow: darkMode
                  ? ""
                  : "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
              }}
              className="hidden md:flex justify-center items-center p-[9px] bg-white rounded-lg dark:bg-dark-secondary "
            >
              {darkMode ? <MainIconSvgDark /> : <MainIconSvg />}
            </div>
            <h6 className="text text-heading_color dark:text-color_v1_dark text-custom_h6">
              {translate("addBlock.setting")}
            </h6>
          </div>
          <div className="md:flex md:gap-5">
            <div className="hidden md:block ps-6 md:ps-[50px] lg:ps-[75px] xl:ps-[100]">
              <SettingSideBar />
            </div>
            <div className="overflow-y-auto w-full h-full md:h-[calc(100vh_-_118px)] ps-6 md:pl-0 pe-6 md:pe-[50px] lg:pe-[100px]">
              <div className="flex justify-start">
                <div className="max-w-screen-2xl w-full">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingPageLayout;
